import $ from 'jquery'
import ParamConsultation from '@/views/parametres/configs/param-consultations'
import ParamExamen from '@/views/parametres/configs/param-examens'
import ParamChirurgie from '@/views/parametres/configs/param-chirurgies'
import BilanSante from '@/views/parametres/configs/param-bilan-sante'
import TarificationCatOnmt from '@/views/parametres/tarifications'
import TarifAdmissions from '@/views/parametres/tarif-admissions'
import TarifActes from '@/views/parametres/tarif-actes'
import ParamPrinter from '@/views/parametres/configs/param-printer'
import ParamAccordionSection from '@/components/param-accordion-section'

export default {
    name: 'prestations-tarifs',
    components: {
        ParamConsultation, ParamExamen, ParamChirurgie, BilanSante,
        TarificationCatOnmt, TarifAdmissions, TarifActes,
        ParamPrinter, ParamAccordionSection
    },
    props: [],
    data() {
        return {
            print_toggler: 0,
            print_data: {}
        }
    },
    computed: {
        activeRole() {
            return this.$store.getters['activeRole'];
        },
        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },
    mounted() {
        setTimeout(() => {
            $('.show-on-fixed').fadeIn();
        }, 500);
    },
    methods: {
        printTrigger(data) {
            this.print_data = {}
            this.print_toggler = (this.print_toggler == 0) ? 1 : 0
            this.print_data = data
        }
    }
}
